export default __webpack_public_path__ + "static/Entenda0051-903afb2c12e5e975e6d783c317f785ff.jpg";